package com.exura.features.plandefinition.data.remote.dto.element

import com.exura.features.plandefinition.domain.model.element.ElementType
import com.exura.features.plandefinition.domain.model.series.HourOfDay
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * DTO for FloatingElement.
 * Extends BasePlanElementDto for Firebase storage compatibility.
 */
@Serializable
@SerialName("floating_element")
data class FloatingElementDto(
    override val elementType: String = ElementType.FLOATING.name,
    override val durationInMinutes: Int,
    override val durationInDays: Int,
    val title: String,
    val instruction: String,
    val deadline: Int? = null,
    val exactTime: HourOfDay? = null,
    override val imageUrl: String? = null
) : BasePlanElementDto()
